import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { IVisualizer, VISUALIZER } from '@jax-data-science/sci-image-visualizer';

import { MainFacade } from '../../../main.facade';
import { ProcessName, ProcessType, ScriptEngine } from '../../../models/request';
import { SubmissionStateService } from '../../../../services/submission-state.service';
import { ProcessService } from '../../../../services/process.service';
import { SavedScriptService } from '../../../../services/saved-script.service';
import { QupathScriptComponent } from '../qupath-script/qupath-script.component';

/**
 * ImageJ macro composer - see jit-ui#143 and jit-parent's `doc/ImageJ-Macro-Guide.md`.
 *
 * The QuPath script composer already does everything this needs (the three script sources, the
 * parameters table, annotations, output folder, reuse-as-saved-script, validate, create rule), and
 * the two worker types take the same `ScriptRequest` shape, so this reuses that component's class
 * and template and only swaps the engine-specific fields: which engine saved scripts are listed
 * for, which process type is validated and submitted, and the hints. Its own selector and
 * `processName` give it separate form state and "submitting" state from the QuPath composer.
 */
@Component({
  selector: 'imagej-macro',
  templateUrl: '../qupath-script/qupath-script.component.html',
  styleUrls: ['../qupath-script/qupath-script.component.scss'],
})
export class ImageJMacroComponent extends QupathScriptComponent {

  constructor(
    mainFacade: MainFacade,
    @Inject(VISUALIZER) plotService: IVisualizer,
    fb: FormBuilder,
    scriptDialogService: DialogService,
    processService: ProcessService,
    savedScriptService: SavedScriptService,
    submissionState: SubmissionStateService,
  ) {
    super(mainFacade, plotService, fb, scriptDialogService, processService, savedScriptService, submissionState);
    this.processName = ProcessName.SCRIPT_IMAGEJ;
    this.engine = ScriptEngine.IMAGEJ_MACRO;
    this.processType = ProcessType.SCRIPT_IMAGEJ;
    this.scriptFileAccept = '.ijm,.txt';
    this.scriptFileExtensions = ['.ijm', '.txt'];
    this.scriptPlaceholder = '// Write or paste your ImageJ macro here, e.g.\nrun("Gaussian Blur...", "sigma=2");\nsaveAs("PNG", outputDir + "blurred.png");';
    this.scriptUploadHint = 'Upload a .ijm file from your computer, or write/paste the macro directly.';
    this.parametersHint = 'a macro reads them with jitParam("key", "fallback"), as text';
  }
}
